export function DefineAiDisclosure({
  title = "AI-generated draft",
  detail = "This content may include assumptions, placeholder estimates, or unvalidated targets. Review before treating it as established fact.",
  testId,
}) {
  return (
    <div
      className="rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-3"
      data-testid={testId}
    >
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-300">{title}</p>
      <p className="mt-1 text-xs text-amber-100">{detail}</p>
    </div>
  );
}
